val flavor: Flavor = StagingFlavor()